import Lottie from 'lottie-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import errorIcon from '../../assets/icons/errorIcon.json';
import { UserService } from '../../app/shared/user/service';

interface Props {
    errorMessage: string;
}

export const ErrorScreen = ({ errorMessage }: Props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
        UserService.sendCriticalError(`${errorMessage} | Path: ${location.pathname}`).catch(err =>
            console.error('Error reporting failed', err)
        );
    }, []);

    const onBack = () => {
        if (window.history.length > 1) {
            // navigate(-1);
            window.location.reload();
        } else {
            navigate('/', { replace: true });
        }
    };

    return (
        <div className="container d-flex align-items-center flex-column justify-content-center h-60vh">
            <Lottie animationData={errorIcon} loop={true} style={{ width: '50%' }} className="my-2" />
            <h6>{t('general.unexpected_err_title')}</h6>
            <p className="text-muted">{t('general.unexpected_err_desc')}</p>
            <button className="btn btn-primary" onClick={onBack}>
                {t('general.button.back')}
            </button>
        </div>
    );
};
